module.exports = __webpack_public_path__ + "img/9.3711d94f.jpg";